/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { PracticeStrictHttpResponse } from '../../practice-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EncounterDetailModel } from '../../models/encounter-detail-model';

export interface EncounterIdGet$Params {
  id: string;
}

export function encounterIdGet(http: HttpClient, rootUrl: string, params: EncounterIdGet$Params, context?: HttpContext): Observable<PracticeStrictHttpResponse<EncounterDetailModel>> {
  const rb = new RequestBuilder(rootUrl, encounterIdGet.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as PracticeStrictHttpResponse<EncounterDetailModel>;
    })
  );
}

encounterIdGet.PATH = '/Encounter/{id}';
